import Vue from "vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
SolidGauge(Highcharts);
import HighchartsVue from "highcharts-vue";
Vue.use(HighchartsVue);
